import {
  Box,
  Container,
  ProgressBar,
  SpaceBetween,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

export default function SessionProgress({
  counted,
  expected,
  missing,
  net,
  percent,
}) {
  return (
    <Container>
      <SpaceBetween size="s">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <Box variant="h3">Session progress</Box>
          <Box color="text-status-inactive" fontSize="body-s">{`${percent}%`}</Box>
        </div>

        <Box>
          <Box variant="span" fontSize="display-l" fontWeight="bold">{counted}</Box>
          {' '}
          <Box variant="span" fontSize="heading-m" color="text-body-secondary">
            {`of ${expected} expected`}
          </Box>
        </Box>

        <ProgressBar value={percent} />

        <div style={{ display: 'flex', gap: 16 }}>
          <Box fontSize="body-s" color="text-body-secondary">
            <b>{counted}</b>
            {' counted'}
          </Box>
          <Box fontSize="body-s" color="text-status-error">
            <b>{missing}</b>
            {' missing'}
          </Box>
          <Box fontSize="body-s" color={net < 0 ? 'text-status-error' : 'text-body-secondary'}>
            {'net '}
            <b>{net > 0 ? `+${net}` : net}</b>
          </Box>
        </div>
      </SpaceBetween>
    </Container>
  );
}

SessionProgress.propTypes = {
  counted: PropTypes.number.isRequired,
  expected: PropTypes.number.isRequired,
  missing: PropTypes.number.isRequired,
  net: PropTypes.number.isRequired,
  percent: PropTypes.number.isRequired,
};
